export const isIipayVoceAFascia = (row) => Number(row?.iipay_ha_fascia) === 1
  || row?.iipay_min_fascia_applicata != null
  || row?.iipay_max_fascia_applicata != null;

export const getIipayFasciaLabel = (row) => {
  const min = row?.iipay_min_fascia_applicata;
  const max = row?.iipay_max_fascia_applicata;
  if (min == null && max == null) return "";
  return min != null && max != null ? `${min}-${max}` : min != null ? `da ${min}` : `fino a ${max}`;
};

export const getMetodoFatturazioneListino = (prestazione) => {
  if (prestazione?.voce_particolare) return "libera";
  if (isIipayVoceAFascia(prestazione)) return "a fascia";
  return ({ 1: "libero", 2: "libera", 3: "listino", 4: "listino/forfait", 5: "orario", 6: "a tabella", 7: "unitaria" })[Number(prestazione?.metodo_fatturazione)] || null;
};

export const getForfaitFasciaDetails = (row) => {
  const range = String(row?.fascia || "").match(/^(\d+)-(\d+|∞)$/);
  if (row?.tipo !== "I" || !range) return {};
  const reference = row.mese_considerato;
  return {
    iipay_min_fascia_applicata: Number(range[1]),
    iipay_max_fascia_applicata: range[2] === "∞" ? null : Number(range[2]),
    iipay_periodo_riferimento: reference?.anno && reference?.mese
      ? `${reference.anno}${String(reference.mese).padStart(2, "0")}` : null,
    iipay_cedolini_riferimento: row.numero_cedolini,
  };
};
